import { Component, computed, ElementRef, inject, input, output, TemplateRef, viewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import type { FormProcessButton } from '@shared/components/kl-form-container/kl-form-container';
import type { ActionDto } from '@shared/components/kl-grid/grid.models';

@Component({
  selector: 'kl-grid-form-toolbar',
  standalone: false,
  templateUrl: './kl-grid-form-toolbar.html',
  styleUrl: './kl-grid-form-toolbar.scss',
})
export class KlGridFormToolbar {
  private readonly translate = inject(TranslateService);

  readonly showToolbarArea = input(true);
  readonly isReadOnly = input(false);
  readonly showAddRow = input(true);
  readonly searchEnabled = input(false);
  readonly importEnabled = input(false);
  readonly exportEnabled = input(false);
  readonly fullscreenEnabled = input(false);
  readonly bulkDeleteEnabled = input(false);
  readonly isFullscreen = input(false);
  readonly rowsLength = input(0);
  readonly processButtons = input<FormProcessButton[]>([]);
  readonly processMenuItems = input<MenuItem[]>([]);
  readonly searchPanelOpen = input(false);
  readonly searchQuery = input('');
  readonly customToolbarVisible = input(true);
  readonly customToolbar = input<ActionDto[]>([]);
  readonly toolbarTemplate = input<TemplateRef<unknown> | null>(null);
  readonly importFileInput = viewChild<ElementRef<HTMLInputElement>>('importFileInput');

  readonly importFileSelected = output<File>();
  readonly addRowClick = output<void>();
  readonly searchClick = output<void>();
  readonly searchQueryChange = output<string>();
  readonly exportClick = output<void>();
  readonly fullscreenClick = output<void>();
  readonly bulkDeleteClick = output<void>();
  readonly customToolbarActionClick = output<ActionDto>();

  readonly fullscreenLabelKey = computed(() => (this.isFullscreen() ? 'exit_fullscreen' : 'fullscreen'));
  readonly fullscreenIcon = computed(() => (this.isFullscreen() ? 'ph ph-corners-in' : 'ph ph-corners-out'));
  readonly importMenuItems = computed<MenuItem[]>(() => [
    {
      label: this.translate.instant('excel'),
      icon: 'ph ph-file-xls',
      command: () => this.openImportPicker(),
    },
  ]);

  openImportPicker(): void {
    this.importFileInput()?.nativeElement?.click();
  }

  onImportFileInput(ev: Event): void {
    const inputEl = ev.target as HTMLInputElement;
    const file = inputEl.files?.[0];
    inputEl.value = '';
    if (file) {
      this.importFileSelected.emit(file);
    }
  }
}
